import { useState, cloneElement } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'

export const Wrapper = ({ children }) => {
  let [isOpen, setIsOpen] = useState(true)
  const close = () => {
    setIsOpen(false)
  }

  return (
    <Dialog open={isOpen} onClose={close} className="relative z-50">
      {/* The backdrop, rendered as a fixed sibling to the panel container */}
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      {/* Full-screen container to center the panel */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        {/* The actual dialog panel  */}
        <DialogPanel className="mx-auto max-w-4xl rounded-xl bg-[#fafafa] p-10">
          {cloneElement(children, { close })}
        </DialogPanel>
      </div>
    </Dialog>
  )
}
